import React from 'react';
import { SkillCard } from '../../components';
import { skills } from '../../data';
import './SkillsSection.css';

const SkillsSection = ({ isVisible }) => {
  return (
    <section id="skills" className="skills-section">
      <div className="skills-container">
        <div className="skills-header">
          <p className="skills-label">Expertise</p>
          <h2 className={`skills-title ${isVisible ? 'animate-slide-up' : 'opacity-0'}`}>
            Technical <span className="gradient-text">Skills</span>
          </h2>
        </div>
        
        <div className="skills-grid">
          {skills.map((skillGroup, index) => (
            <SkillCard 
              key={index}
              skillGroup={skillGroup}
              isVisible={isVisible}
              animationDelay={index * 0.1}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;
